import { createSlice } from '@reduxjs/toolkit'
import { fetchScheduleReport } from './thunks/schedules';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    isNoteActive: false,
    filteredCaption: "",
    showAccountCode: true
}

const schedule = createSlice({
    name: 'SCHEDULESLICE',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setScheduleNoteActiveState(state, action){
          state.isNoteActive = !state.isNoteActive
        },
        setScheduleFilteredCaption(state, action) {
            state.filteredCaption = action.payload
        },
        setShowAccountCode(state, action) {
          state.showAccountCode = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchScheduleReport.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchScheduleReport.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchScheduleReport.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, data, setScheduleNoteActiveState, setScheduleFilteredCaption, setShowAccountCode } = schedule.actions

export default schedule;